(function () {
  if (window.__quickAddSizesLoaded) return;
  window.__quickAddSizesLoaded = true;

  var SELECTED = 'is-selected';
  var NEEDS_SIZE = 'needs-size';

  function setVariant(form, variantId) {
    if (!form || !variantId) return;
    var idInput = form.querySelector('[data-quick-add-variant-input]') || form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
  }

  // Talla: si el holder tiene botón "Añadir a carrito" (rediseño THORO), la
  // talla solo se selecciona y es el botón el que añade. Sin botón, se
  // mantiene el comportamiento anterior: tocar la talla añade directamente.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-size-add-to-cart]');
    if (!btn || btn.disabled) return;

    // Block click if user was dragging the size slider
    var slider = btn.closest('.quick-add__sizes');
    if (slider && slider.dataset.wasDragging) return;

    e.preventDefault();

    var form = btn.form || btn.closest('form');
    setVariant(form, btn.dataset.variantId);

    var holder = btn.closest('[data-quick-add-holder]');
    var submit = holder && holder.querySelector('[data-quick-add-submit]');

    if (submit) {
      var already = btn.classList.contains(SELECTED);
      if (slider) {
        slider.querySelectorAll('[data-size-add-to-cart]').forEach(function (b) {
          b.classList.remove(SELECTED);
          b.setAttribute('aria-pressed', 'false');
        });
      }
      if (!already) {
        btn.classList.add(SELECTED);
        btn.setAttribute('aria-pressed', 'true');
      }
      holder.classList.remove(NEEDS_SIZE);
      holder.classList.toggle('has-size', !already);
      return;
    }

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', { detail: { button: btn } })
    );
  });

  // Botón "Añadir a carrito" del rediseño: exige una talla seleccionada.
  document.addEventListener('click', function (e) {
    var submit = e.target.closest('[data-quick-add-submit]');
    if (!submit || submit.disabled) return;
    e.preventDefault();

    var holder = submit.closest('[data-quick-add-holder]');
    var selected = holder && holder.querySelector('[data-size-add-to-cart].' + SELECTED);

    if (!selected) {
      // Sin talla: se marca el holder y se avisa (aria-live) sin añadir nada.
      holder.classList.remove(NEEDS_SIZE);
      void holder.offsetWidth; // reinicia la animación
      holder.classList.add(NEEDS_SIZE);
      var live = holder.querySelector('[data-quick-add-live]');
      if (!live) {
        live = document.createElement('span');
        live.className = 'visually-hidden';
        live.setAttribute('role', 'status');
        live.setAttribute('aria-live', 'polite');
        live.setAttribute('data-quick-add-live', '');
        holder.appendChild(live);
      }
      live.textContent = submit.dataset.chooseSizeText || '';
      var sizes = holder.querySelector('.quick-add__sizes');
      if (sizes) sizes.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    setVariant(submit.form || submit.closest('form'), selected.dataset.variantId);

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', { detail: { button: submit } })
    );
  });

  // Drag-to-scroll for size sliders on desktop
  var dragState = null;

  document.addEventListener('mousedown', function (e) {
    var slider = e.target.closest('.quick-add__sizes');
    if (!slider) return;
    dragState = {
      slider: slider,
      startX: e.pageX,
      scrollLeft: slider.scrollLeft,
      moved: false,
    };
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragState) return;
    var dx = e.pageX - dragState.startX;
    if (Math.abs(dx) > 3) dragState.moved = true;
    dragState.slider.scrollLeft = dragState.scrollLeft - dx;
  });

  document.addEventListener('mouseup', function () {
    if (!dragState) return;

    // Se guarda el slider en una variable local: el setTimeout de abajo se
    // ejecuta cuando dragState ya vale null, así que leer dragState.slider
    // dentro del callback lanzaba un TypeError y el flag wasDragging nunca se
    // borraba. A partir del primer arrastre, el guard de arriba
    // (if (slider.dataset.wasDragging) return) bloqueaba para siempre los
    // clics sobre las tallas de ese slider.
    var slider = dragState.slider;
    var moved = dragState.moved;
    dragState = null;

    slider.style.cursor = '';
    slider.style.userSelect = '';

    if (moved) {
      slider.dataset.wasDragging = '1';
      setTimeout(function () {
        delete slider.dataset.wasDragging;
      }, 100);
    }
  });
})();
